import scroller from '../../scroller';
import vars from '../../../helpers';
import schema1 from './2-1-1';
import schema2 from './2-1-2';

const pitures = ({img, endTrigger, end}) => {
	let start = '0%';

	const cont = document.querySelector(`${img}`);
	const index = cont.dataset.schemeIndex;
	const eh = cont.clientHeight;
	const wh = window.innerHeight;
	let tm = null;

	if (index === '0') {
		tm = schema1;
		schema1.init(cont);
	} else if (index === '1') {
		tm = schema2;
		schema2.init(cont);
	}

	start = `${(wh - eh) / 2}`;

	if (!vars.isMobile()) {
		ScrollTrigger.create({
			trigger: img,
			start: `top-=${start} top`,
			endTrigger,
			end,
			pin: true,
			pinType: 'transform',
			pinReparent: false,
			pinSpacing: true,
			scrub: 0.5,
			// markers: {
			// 	startColor: 'red',
			// 	endColor: 'red',
			// },
			scroller: scroller.getElement(),
			onEnter: () => {
				tm.play();
			},
			onEnterBack: () => {
				tm.play();
			},
			onLeave: () => {
				tm.pause();
			},
			onLeaveBack: () => {
				tm.pause();
			},
		});
	} else {
		ScrollTrigger.create({
			trigger: img,
			endTrigger: img,
			scrub: 0.5,
			scroller: scroller.getElement(),
			// markers: {
			// 	startColor: 'red',
			// 	endColor: 'red',
			// },
			onEnter: () => {
				tm.play();
			},
			onEnterBack: () => {
				tm.play();
			},
			onLeave: () => {
				tm.pause();
			},
			onLeaveBack: () => {
				tm.pause();
			},
		});
	}
};

export {pitures};
